
export default {
  EQUIPMENTS_LIST: "Liste des équipements",
  ADD_EQUIPMENT: "Ajouter un équipement",
  EQUIPMENT_ADDED: "Équipement ajouté",
  EDIT_EQUIPMENT: "Modifier un équipement",
  EQUIPMENT_UPDATED: "Équipement mis à jour",
  DELETE_THIS_EQUIPMENT: "Supprimer cet équipement ?",
  EQUIPMENT_DELETED: "Équipement supprimé",
  MODEL: "Modèle",
  PURCHASE_YEAR: "Date d'achat",
  SERVICE_PLAN: "Plan de service",
  FORMAT : "Format",
  SOFTWARE: "Logiciel",
  LOAN_YEAR: "Date de prêt",
  LOANED_BY_SUPPLIER: "Prêté par le fournisseur",
  LOANED_BY_SUPPLIER_QUESTION: "Prêté par le fournisseur ?",

};
